import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image3 from "../../../Img/Proyectos/ProyectosDesarrollo/SayulitaRevolucion/65d5055b87f3383d44e686b6_CONJ 01.jpg"
import image2 from "../../../Img/Proyectos/ProyectosDesarrollo/SayulitaRevolucion/65d5056bcf8d6badd08f1661_CASA 03.jpg"
import image1 from "../../../Img/Proyectos/ProyectosDesarrollo/SayulitaRevolucion/65d5055613675a13fc584280_Vista 06.jpg"
import image4 from "../../../Img/Proyectos/ProyectosDesarrollo/SayulitaRevolucion/65d505512ec1f5f4a19ecdaf_02 Planta Alta.jpg"
import image5 from "../../../Img/Proyectos/ProyectosDesarrollo/SayulitaRevolucion/65d50551b001de1a96e1716c_01 Planta Baja.jpg"
import image6 from "../../../Img/Proyectos/ProyectosDesarrollo/SayulitaRevolucion/65d50551b93ea26f1a361e94_02 Planta Azoteas.jpg"


function ProyectoSayulitaRevolucion() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Playa y Montaña - Sayulita Revolución</title>
            </Helmet>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-casas-de-descanso">Playa y Montaña</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Sayulita Revolución</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Sayulita Revolución</h1>
                <h6 className="py-2 m-0 p-0">Sayulita, Nay.<h6>2015</h6></h6>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProyectoSayulitaRevolucion;
